import React, { useState } from "react";
import Searcher from "./Projects/UI/Searcher";
import SplitLayerComparison from "./SplitLayerComparison/SplitLayerComparison ";

const Test = () => {
  return (
    <div>
      <Searcher projectId={null} />
      <SplitLayerComparison/>
    </div>
  );
};

export default Test;
